import css from 'styled-jsx/css';
import { colors, typography } from '../../../../config/styles';
import { svgUrl } from '../../../../utils/staticUrls';

export const LinearPodDesktopStyles = css`
  .search-results--linearCell {
    border-top: 1px solid #f0f0f0;
  }

  .bestseller-ribbon-container {
    display: flex;
    align-self: flex-start;
  }
  .pod {
    display: flex;
    flex-direction: row;
    padding: 20px 20px 14px 20px;
    border-left: none;
    background-color: ${colors.white.shade1};
    position: relative;
    width: 100%;
  }
  .pod__head {
    position: relative;
  }

  .pod-rating {
    display: flex;
    margin-bottom: 14px;
  }
  div.pod-action-rebranding {
    width: 214px;
  }
  .pod-title {
    text-transform: uppercase;
    margin-bottom: 5px;
    color: ${colors.black.shade7};

    &.title-rebrand {
      font-size: 13px;
      line-height: 16px;
      color: ${colors.gray.shade44};
      letter-spacing: 0;
    }
  }
  .subTitle-rebrand {
    font-weight: bold;
    font-size: 16px;
    line-height: 16px;
    color: ${colors.gray.shade40};
    padding-right: 44px;
    display: block;
  }
  .pod-details {
    padding: 0 15px 10px 8px;
    margin-top: 1px;
    position: relative;
  }
  .link-container {
    width: 76%;
  }
  .pod-link {
    text-decoration: none;
    color: inherit;
  }

  .pod-title-wrapper {
    margin-bottom: 18px;
  }

  .pod-action {
    @mixin tabletToDesktop {
      width: 200px;
      margin-bottom: 12px;
    }

    margin-top: 10px;
  }
  .pod-button-add-to-cart {
    display: flex;
    justify-content: center;
  }
  .pod-button-add-to-cart-spinner {
    margin-right: 8px;
  }
  .section-head {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 19.6%;
  }
  .pod-sellerText {
    font-size: 13px;
    color: #888;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-top: 2px;
    display: inline-block;
    &.seller-text-rebrand {
      margin-top: 8px;
      font-family: inherit;
      font-size: 13px;
      line-height: 16px;
      color: ${colors.gray.shade15};
    }
  }
  .seller-icon {
    background-repeat: no-repeat;
    margin-left: 4px;
    margin-right: 6px;
    display: inline-block;
    vertical-align: middle;
  }
  .falabellaIcon {
    background-image: url(${svgUrl('falabella.svg')});
    height: 18px;
    width: 12px;
    margin-top: -9px;
  }
  .sodimacIcon,
  .homecenterIcon {
    background-image: url(${svgUrl('sodimac.svg')});
    height: 18px;
    width: 18px;
    margin-top: -3px;
  }
  .tottusIcon {
    background-image: url(${svgUrl('tottus.svg')});
    height: 18px;
    width: 18px;
    margin-top: -9px;
  }
  .linioIcon {
    background-image: url(${svgUrl('linio.svg')});
    height: 18px;
    width: 18px;
    margin-top: -9px;
  }
  .section-body {
    display: flex;
  }

  .section-body--left {
    width: 65.4%;
    display: flex;
    flex-direction: column;
  }

  .section-body--right {
    width: 34.6%;
    padding-top: 0;
  }

  .tabContent {
    min-height: 62px;
  }

  :global(.swatch--container) {
    margin-top: 10px;
  }

  :global(.shipping-details) {
    margin-bottom: 5px;
  }

  :global(.pod-badges) {
    padding-bottom: 11px;
  }

  .patrocinado-pod {
    color: ${colors.gray.shade44};
    font-weight: 400;
    font-size: ${typography.sm};
    letter-spacing: 1px;
    line-height: 1.3;
    margin-top: 16px;
    margin-bottom: 6px;
    max-height: 16px;
  }
  .patrocinado-title {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
  .event-sticker-wrapper {
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
    margin-top: 5px;
  }

  .installments-text {
    margin-bottom: 12px;
    margin-top: 3px;
    span {
      color: #343e49;
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
      justify-content: center;
    }
  }
  .cmr-icon {
    background-image: url(${svgUrl('cmr-icon.svg')});
    height: 12px;
    width: 19px;
    margin-left: 2px;
    display: inline-block;
  }
`;
